import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const InsuredName = (props) => {
  return (
    <FormGroup controlId="insuredName">
      <Col componentClass={ControlLabel} sm={5}>
        Insured Name/ Corporate Name *
      </Col>
    <Col sm={7}>
        <FormControl
          type="text"
          value={props.insuredName}
          onChange={props.handleChangeInsuredName}
          id="insuredName"
          required autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

InsuredName.propTypes = {
  insuredName: PropTypes.string,
  handleChangeInsuredName: PropTypes.func
};

export default InsuredName;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/insuredName/InsuredName.js